import { trigger } from '@angular/animations';
import { NgFor, NgIf } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { LottieComponent } from 'ngx-lottie';
import { Subject, takeUntil } from 'rxjs';
import { maxHeightIf } from 'src/app/animations/max-height.if.animation';
import { moveLeftIf } from 'src/app/animations/move-left.if.animation';
import { ArchiveItem, ArchiveService } from 'src/app/services/archive.service';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { TooltipDirective } from 'src/app/shared/directives/tooltip.directive';
import { CircleProgressBarComponent } from '../../../shared/components/circle-progress-bar/circle-progress-bar.component';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { DataUnitsPipe } from '../../../shared/pipes/data-units.pipe';

@Component({
  selector: 'app-archive-download-info',
  templateUrl: './archive-download-info.component.html',
  styleUrls: ['./archive-download-info.component.scss'],
  animations: [
    trigger('archiveBox', moveLeftIf),
    trigger('archiveBody', maxHeightIf(200)),
    trigger('downloadItem', maxHeightIf(60)),
  ],
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    LottieComponent,
    SvgComponent,
    CircleProgressBarComponent,
    LoadingIndicatorComponent,
    DataUnitsPipe,
    ButtonDirective,
    TooltipDirective,
  ],
})
export class ArchiveDownloadInfoComponent implements OnDestroy {
  minimized = false;
  lastItem: ArchiveItem;
  destroyed$ = new Subject<void>();

  constructor(public archiveService: ArchiveService) {
    this.archiveService.onArchiveCreated$.pipe(takeUntil(this.destroyed$)).subscribe(item => {
      this.lastItem = this.archiveService.items[this.archiveService.items.length - 1];
      if (item.partInfo || this.archiveService.items.length > 1) this.minimized = false;
      else this.minimized = true;
    });
  }

  get totalSize() {
    return this.archiveService.items.reduce((acc, item) => acc + Number(item.archive.total_size), 0);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
